/**
 * Shows success/error feedback only for the customer form that was submitted.
 * Shopify shares one `form` state across all {% form 'customer' %} tags on a page.
 */
const CUSTOMER_FORM_STORAGE_KEY = 'customerFormSource';

function setCustomerFormSource(formKey) {
  if (!formKey) return;
  try {
    sessionStorage.setItem(CUSTOMER_FORM_STORAGE_KEY, formKey);
  } catch (error) {
    /* sessionStorage unavailable */
  }
}

function getCustomerFormSource() {
  const urlSource = new URLSearchParams(window.location.search).get('customer_form');
  let storedSource = null;

  try {
    storedSource = sessionStorage.getItem(CUSTOMER_FORM_STORAGE_KEY);
    sessionStorage.removeItem(CUSTOMER_FORM_STORAGE_KEY);
  } catch (error) {
    /* sessionStorage unavailable */
  }

  return storedSource || urlSource;
}

function initCustomerFormFeedback() {
  const feedback = document.querySelectorAll('.customer-form-feedback[data-customer-form-key]');
  if (!feedback.length) return;

  const source = getCustomerFormSource();

  feedback.forEach((element) => {
    const isMatch = Boolean(source) && element.dataset.customerFormKey === source;

    element.classList.toggle('customer-form-feedback--is-visible', isMatch);
    element.toggleAttribute('hidden', !isMatch);

    if (!isMatch) return;

    const input = document.querySelector(`[data-customer-form-input="${source}"]`);
    if (input) {
      const describedBy = element.id;
      if (describedBy) input.setAttribute('aria-describedby', describedBy);
      if (element.getAttribute('role') === 'alert') {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
    }
  });
}

function bindCustomerFormWrappers() {
  document.querySelectorAll('[data-customer-form-key]:has(form)').forEach((wrapper) => {
    const formKey = wrapper.dataset.customerFormKey;
    const form = wrapper.querySelector('form');

    if (!form || form.dataset.customerFormBound === 'true') return;

    form.dataset.customerFormBound = 'true';
    form.addEventListener(
      'submit',
      () => {
        setCustomerFormSource(formKey);
      },
      { capture: true }
    );
  });
}

function runCustomerFormFeedback() {
  bindCustomerFormWrappers();
  initCustomerFormFeedback();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runCustomerFormFeedback);
} else {
  runCustomerFormFeedback();
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted) runCustomerFormFeedback();
});
